<template>
	<div :class="wrapper_class">
		<date-range-picker style="height: 0;"
      class="calendar-be-room z-index-1039"
			ref="date"
      :min-date="min_date" 
      :max-date="max_date" 
      v-model="date" 
      :opens="opens" 
      :show-dropdowns="!disabledActionChangeMonth"
      :auto-apply="true" 
      :ranges="false"
      :single-date-picker="type_date_picker"
			@start-selection="startSelection"
			@hover-date="controlStartDate"
			@select="endSelection"
      @toggle="togglePopup"
      @update="emitSelection"
      @change-month="changeMonth">
      <template v-slot:input="picker">
      	<template v-if="only_for_page == 'booking'">
        	{{$formatDate(date.startDate)}} - {{$formatDate(date.endDate)}}
      	</template>
      	<template v-if="only_for_page == 'homepage'">
      		<div class="w-100">
            <div class="row no-gutters text-left">
							<div class="col-1 align-self-center">
								<img src="../../../assets/img/icon/calendar-dark.png" width="15">
							</div>
							<div class="col-11 align-self-center">
								<div class="w-100 pl-1">
									<p class="mb-0 body-3">{{$t('hotel.date.check-in')}} - {{$t('hotel.date.check-out')}}</p>
									<p class="mb-0 body-2-1">{{$formatDate(date.startDate)}} - {{$formatDate(date.endDate)}}</p>
								</div>
							</div>
						</div>
					</div>
      	</template>
        <template v-if="only_for_page === 'search-room'">
          <div class="d-flex align-items-center p-3 wrapper">
            <svg class="mr-2-5 icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M16.411 2.769v0.75c2.755 0.216 4.575 2.093 4.578 4.972l.011 8.426c.004 3.138-1.968 5.07-5.128 5.075l-7.72.01c-3.141.004-5.137-1.973-5.141-5.12L3 8.553c-.004-2.898 1.751-4.77 4.506-5.023v-0.75a.764.764 0 0 1 .76-.771c.435 0 .761.33.762.77v0.7l5.865-.008v-0.7a.764.764 0 0 1 .76-.77c.425 0 .761.33.762.77ZM4.521 8.862l14.948-.02v-.35c-.043-2.149-1.12-3.276-3.055-3.444v.77a.731.731 0 0 1-1.24.77v-.81l-5.865.009v.81a.731.731 0 0 1-1.26.001v-.77c-1.925.193-2.99 1.325-2.987 3.493v.251ZM15.24 13.404v.011a.848.848 0 0 0 .84.799.837.837 0 0 0 .79-.853.84.84 0 0 0-.832-.85.83.83 0 0 0-.798.893ZM16.055 17.892a.85.85 0 0 1-.82-.848.845.845 0 0 1 .808-.853h.01a.846.846 0 0 1 .84.849.845.845 0 0 1-.838.852ZM11.172 13.42a.848.848 0 0 0 .85.799.837.837 0 0 0 .78-.86.84.84 0 0 0-.82-.8.83.83 0 0 0-.81.861ZM12.026 17.847a.85.85 0 0 1-.83-.799.845.845 0 0 1 .808-.861.846.846 0 0 1 .81.798.845.845 0 0 1-.788.862ZM7.104 13.455a.848.848 0 0 0 .85.799.837.837 0 0 0 .778-.86.84.84 0 0 0-.82-.8.83.83 0 0 0-.808.861ZM7.958 17.852a.85.85 0 0 1-.85-.799.845.845 0 0 1 .81-.861.846.846 0 0 1 .82.799.845.845 0 0 1-.78.861Z" fill="#999"/>
            </svg>
            <div class="w-100">
              <p class="body-3 mb-0 label text-truncate min-w-0">Check in - Check out</p>
              <p class="body-2-1 mb-0 value text-truncate min-w-0">{{ $formatDateRange(date.startDate, date.endDate) }}</p>
            </div>
          </div>
        </template>
      </template>
      <div slot="footer" slot-scope="data" class="slot">
      	<div class="p-3">
      		<div class="w-100 mb-3">
						<div class="w-100 no-ws mb-1">
							<div class="d-inline-block align-middle mr-2">
								<svg width="6" height="7" viewBox="0 0 6 7" fill="none" xmlns="http://www.w3.org/2000/svg">
									<rect y="0.5" width="6" height="6" rx="3" fill="#222222"/>
								</svg>
							</div>
							<p class="mb-0 body-2-2 d-inline-block align-middle">Prices are in {{getCurrency.name}} ({{getCurrency.code}})</p>
						</div>
						<div class="w-100 no-ws mb-1">
							<div class="d-inline-block align-middle mr-2">
								<svg width="6" height="7" viewBox="0 0 6 7" fill="none" xmlns="http://www.w3.org/2000/svg">
									<rect y="0.5" width="6" height="6" rx="3" fill="#222222"/>
								</svg>
							</div>
							<p class="mb-0 body-2-2 d-inline-block align-middle">The price shown is the price per night</p>
						</div>
						<div class="w-100 no-ws mb-1" v-if="getBeFilter.promo_code != ''">
							<div class="d-inline-block align-middle mr-2">
								<svg width="6" height="7" viewBox="0 0 6 7" fill="none" xmlns="http://www.w3.org/2000/svg">
									<rect y="0.5" width="6" height="6" rx="3" fill="#222222"/>
								</svg>
							</div>
							<p class="mb-0 body-2-2 d-inline-block align-middle">Promo code applied : <b>{{getBeFilter.promo_code}}</b></p>
						</div>
      		</div>
	        <div class="d-inline-block align-middle mr-4">
	        	<div class="border-semi-grey position-relative d-inline-block align-middle mr-2" style="height:30px;width:30px; overflow:hidden;">
	        		<div class="calendar-be-custom-date-cta-sm">
	        		</div>
	        	</div>
	        	<p class="body-2-2 d-inline-block aling-middle mb-0">No Check-in</p>
	        </div>
	        <div class="d-inline-block align-middle mr-4">
	        	<div class="border-semi-grey position-relative d-inline-block align-middle mr-2" style="height:30px;width:30px; overflow:hidden;">
	        		<div class="calendar-be-custom-date-ctd-sm">
	        		</div>
	        	</div>
	        	<p class="body-2-2 d-inline-block aling-middle mb-0">No Check-out</p>
	        </div>
	        <div class="d-inline-block align-middle">
	        	<div class="border-semi-grey position-relative d-inline-block align-middle mr-2 pt-1 text-center" style="height:30px;width:30px; overflow:hidden;">
	        		<p class="mb-0 font-regular text-22 lh-1 text-danger">x</p>
	        	</div>
	        	<p class="body-2-2 d-inline-block aling-middle mb-0">Sold Out</p>
	        </div>
	      </div>
      </div>
      <template #date="data">
        <CalendarRoomItem :ori_data="data.date" :api_data="date_active"></CalendarRoomItem>
      </template>
    </date-range-picker>
	</div>
</template>
<script>
	import DateRangePicker from 'vue2-daterange-picker';
  import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
	import moment from 'moment'
	import {mapGetters,mapMutations} from 'vuex';
  import {get} from '@/services/index.js';
  import CalendarRoomItem from '@/components/hotel/be/CalendarRoomItem'

	export default{
		props:{
			date_default:{
				type: Object,
				default: () => {}
			},
			wrapper_class:{
				type: String,
				default: '' 
			},
			is_double:{
				type: Boolean,
				default: true 
			},
			filter_guest:{
				type: Object,
				default: () => {}
			},
			opens:{
				type: String,
				default: 'right'
			},
			only_for_page:{
				type: String,
				default: 'booking'
			}
		},
		components:{
			DateRangePicker,
			CalendarRoomItem
		},
		data(){
			return{
				min_date: moment().toDate(),
				max_date: moment().add(23, 'months').endOf('month').toDate(),
				date: {
	        startDate: moment().toDate(),
	        endDate: moment().add(2,'d').toDate(),
	      },
	      date_active: [],
	      is_open: false,
				is_changing_month: null,
				fixed_start: null,
        disabledDate: [],
        disabledActionChangeMonth: false
			}
		},
		computed:{
			...mapGetters(['getMerchant','getCurrency','getBeFilter']),
			type_date_picker(){
				return this.is_double ? false : 'range'
			},
			guest_n_promo(){
				return `${this.getBeFilter.guest.adult}${this.getBeFilter.guest.child}${this.getBeFilter.guest.infant}${this.getBeFilter.promo_code}`
			},
      savedDate(){
        const { date: { check_in, check_out } } = this.getBeFilter; 
        return this.$formatDateRange(check_in, check_out);
      }
		},
		watch:{
			guest_n_promo(){
				this.date_active = []
			},
      disabledActionChangeMonth(){
        this.toggleDisabledAction()
      },
      savedDate(newDate, oldDate){
        const currentDate = this.$formatDateRange(this.date.startDate, this.date.endDate);
        if(currentDate !== newDate){
          const { date: { check_in: startDate, check_out: endDate } } = this.getBeFilter; 
          this.date = { startDate, endDate }
        }
      }
		},
		mounted(){
			if(this.date_default.startDate && this.date_default.endDate){
				this.date = this.$deepCopy(this.date_default); 
			}else{
        const savedDate = this.$deepCopy(this.getBeFilter.date)
				this.date = {
					startDate:  savedDate.check_in,
					endDate:  savedDate.check_out,
				}
			}
		},
		methods:{
			formatDateNumber(value){
	      return moment(value).format("D")
	    },
	    emitSelection(date){
	    	this.$emit('finish', this.date)
	    },
	    togglePopup(open){
	    	this.is_open = open
        this.$emit('togglePopup', open);
	    	// if(!open){
	    	// 	this.date_active = []
	    	// }
	    },
			toggleCalendar(){
				setTimeout(() => {
					this.$refs.date.togglePicker()
				}, 100);
				// console.log("🚀 ~ toggleCalendar ~ this.$refs.date:", this.$refs.date)
			},
	    isMonthInDateActive(month){
	    	let month_active_index = this.date_active.findIndex(date=>{
      		let loop_date = moment(date.month).format("M-YYYY")
      		let selected_date = moment(month).format("M-YYYY")
      		if(loop_date == selected_date){
      			return true
      		}else{
      			return false
      		}
      	})
	      return month_active_index
	    },
	    changeMonth(monthDate,index){
	    	if(this.is_open || (this.opens == 'inline' && !this.is_open)){
			    // this.date_active = []
	    		let month_active_index = this.isMonthInDateActive(monthDate)
					if(month_active_index == -1){
						if (this.is_changing_month != null) {
							clearTimeout(this.is_changing_month)
						}
						this.is_load = true
						let self = this
						this.is_changing_month = setTimeout(() => {
							if(this.date_active.length == 0 || month_active_index == -1){
								this.date_active.push({
									month: moment(monthDate).format(),
									loading: true,
									dates: []
								})
								this.loadRoomDate(moment(monthDate).format())
							}

							if(this.is_double){
								let other_month = index == 0 ? moment(monthDate).add(1,'M').format() : moment(monthDate).subtract(1,'M').format()
								let other_month_active_index = this.isMonthInDateActive(other_month)
								if(other_month_active_index == -1){
									this.date_active.push({
										month: other_month,
										loading: true,
										dates: []
									})
									this.loadRoomDate(other_month)
								}
								if(this.date_active.length > 2){
									let first_month = this.isMonthInDateActive(monthDate)
									let second_month = this.isMonthInDateActive(other_month)
									let new_data = [this.date_active[first_month],this.date_active[second_month]]
									this.date_active = new_data
								}
							}else{
								if(this.date_active.length > 1){
									let month_fix_active_index = this.isMonthInDateActive(monthDate)
									if(month_fix_active_index == -1){
										this.date_active = []
										this.date_active.push({
											month: moment(monthDate).format(),
											loading: true,
											dates: []
										})
										this.loadRoomDate(moment(monthDate).format())
									}else{
										let new_data = [this.date_active[month_fix_active_index]]
										this.date_active = new_data
									}
								}
							}
						}, 500)
					}
	    	}
		  },
		  loadRoomDate(month){
        this.disabledActionChangeMonth = true
	      let start_date = moment(month).toDate()
	      let end_date = moment(month).endOf("month").format('YYYY-MM-DD')
	      let is_this_month = moment().format("M-YYYY") == moment(start_date).format("M-YYYY")
	      if(is_this_month){
	      	start_date = moment().format('YYYY-MM-DD')
	      }else{
	      	start_date = moment(start_date).format('YYYY-MM-DD')
	      }

	      let param = {
	        merchant_id: this.getMerchant.id,
	        start_date: start_date,
	        end_date: end_date,
	        adult: this.getBeFilter.guest.adult ? this.getBeFilter.guest.adult : this.$defaultFilterBE('adult'),
	        child: this.getBeFilter.guest.child ? this.getBeFilter.guest.child : 0,
	        infant: this.getBeFilter.guest.infant ? this.getBeFilter.guest.infant : 0,
          use_promotion_combine:true,
					promo_code: this.getBeFilter.promo_code
	      }
	      get("CORE_HOTEL", "search-availability",
	        param
	      ).then(response => {
	        let res = response.data
					let month_active_index = this.isMonthInDateActive(month)
	        if (res.success) {
	        	if(month_active_index != -1){
	        		this.date_active[month_active_index].dates = res.data
	        		this.date_active[month_active_index].loading = false
	        	}
	        }else{
						if(month_active_index != -1){
							this.date_active[month_active_index].dates = []
							let total_day = moment(start_date,'YYYY-MM-DD').daysInMonth()
							let fake_data = []
							let date_loop = moment(start_date,'YYYY-MM-DD').format()
							for (let i = 0; i < total_day; i++) {
								fake_data.push({
									date: moment(date_loop).format('YYYY-MM-DD'),
									availability: 0
								})
								date_loop = moment(date_loop).add(1,'d') 
								if(i+1 == total_day){
									this.date_active[month_active_index].dates = fake_data
									this.date_active[month_active_index].loading = false
								}
							}
						}
					}
	      }).finally(() => {
          this.disabledActionChangeMonth = false
        })
	    },
      formatDateApi(date){
        return moment(date).format("YYYY-MM-DD");
      },
      disableDateItem(date, action='add'){
        const nextElement = document.getElementById(`date-${date}`);
        if(nextElement){
          const parentElement = nextElement.parentNode;
          if(action === 'add') parentElement.classList.add("disabled");
          else parentElement.classList.remove("disabled");
        }
      },
			startSelection(date){
				this.fixed_start = this.$refs.date.start
        let selectedData = this.getDetailDate(date);
        this.disabledDate = [];
        if(selectedData && selectedData.min_nights > 1){
          for (let i = 1; i < selectedData.min_nights; i++) {
            const disabledDateItem = this.formatDateApi(moment(date).add(i, 'd'));
            this.disableDateItem(disabledDateItem)
            this.disabledDate.push(disabledDateItem)
          }
        }
			},
			endSelection(date){
				this.fixed_start = null
        this.disabledDate.forEach(dateItem => {
          this.disableDateItem(dateItem, 'remove');
        });
        this.disabledDate = []
			},
			controlStartDate(date){
				if(this.fixed_start != null){
					let current_start = this.$refs.date.start
					if(!(moment(this.fixed_start).isSame(current_start,'day'))){
						this.$refs.date.start = this.fixed_start
					}
				}
        if(this.disabledDate.length > 0){
          const formattedDate = this.formatDateApi(date);
          const dateInDisabled = this.disabledDate.find(dateItem => dateItem === formattedDate);
          if(dateInDisabled){
            this.disableDateItem(dateInDisabled, 'add');
          }
        }
			}, 
      getDetailDate(date){
        if(this.date_active.length == 0) return null;

        const currentMonth = moment(date).format("M-YYYY");
        const selectedMonth = this.date_active.find(month => moment(month.month).format("M-YYYY") === currentMonth);
        if(!selectedMonth) return null;

        const currentDate = moment(date).format("YYYY-MM-DD");
        const selectedDate = selectedMonth.dates.find(date => date.date === currentDate);
        if(!selectedDate) return null;

        return selectedDate;
      },
      testDisabledPicker(){
        this.testDisabled = !this.testDisabled
      },
      toggleDisabledAction(){
        const prevElements = document.querySelectorAll('.next.available');
        if(this.$isEmpty(prevElements)) return;
        const nextElements = document.querySelectorAll('.prev.available');
        if(this.$isEmpty(nextElements)) return;

        const mappingDisabledAttr = (elements) => {
          Array.from(elements).forEach(item => {
            if (this.disabledActionChangeMonth) {
              item.classList.add('disabled-non-form'); // Add CSS class to visually disable
            } else {
              item.classList.remove('disabled-non-form');
            }
          });
        };

        mappingDisabledAttr(prevElements)
        mappingDisabledAttr(nextElements)
      }
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/hotel/be/CalendarRoom.vue